import {
  TypeProductPage,
  TypeCollectionMarketingCard,
  TypeCollectionMarketingCardFields,
} from '@/core/generated-types';

export const orderedPages = (
  productPages: TypeProductPage[],
  marketingPages: TypeCollectionMarketingCard[],
) => {
  const combinedPages = [...productPages, ...marketingPages];
  const result = [];

  for (const page of combinedPages) {
    const fields = page.fields as unknown as TypeCollectionMarketingCardFields;
    if (fields.listedOrder !== undefined) {
      const index = fields.listedOrder - 1;
      result.splice(index, 0, page);
    } else {
      result.push(page);
    }
  }

  return result.filter(Boolean);
};
